<template>
  <div class="page-guide">
    <div class="logo-wrap">
      <div class="logo" />
    </div>
    <div class="description">{{ `您的会员，微信昵称“${user && user.nickname}”，邀请您使用便捷的私教约课系统“身材觉醒”` }}</div>
    <div class="mp-item">
      <p class="title">长按二维码关注我们的教练端服务号“陨石身材教练”</p>
      <p class="qrcode">
        <img src="https://open.weixin.qq.com/qr/code?username=gh_8ba1eb1304b7">
      </p>
    </div>
  </div>
</template>

<script>
import wechatApi from '@/api/wechat';

export default {
    data() {
        return {
            openid: null,
            user: null,
        };
    },
    async created() {
        const { openid } = this.$route.params;
        this.openid = openid;
        this.user = await wechatApi.getUser(openid);
    },
};
</script>

<style lang="scss" scoped>
.page-guide {
    background-color: white;
    padding-top: 8.8vw;
    padding-bottom: 8.8vw;
}

.logo {
    width: 80vw;
    height: 35.2vw;
    margin: 0 auto;
    background-image: url(../../assets/images/logo.png);
    background-size: cover;
}

.description {
    margin: 11.2vw 14.4vw 0;
}

.mp-item {
    .title {
        padding: 8.8vw 14.4vw 3.2vw;
    }

    .qrcode {
        border-top: 1px solid #cfcdcd;
        border-bottom: 1px solid #cfcdcd;
        padding: 5.6vw;

        > img {
            width: 100%;
            height: 100%;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/containers/guide/Guide.vue